import PageHeader from 'src/components/organisms/PageHeader';
import Footer from 'src/components/molecules/footer/Footer';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import CustomButton from 'src/components/atoms/buttons/CustomButton';
import ContentCardsContainer, { CardType, ContentCard } from 'src/components/organisms/ContentCard';
import { CustomDataGrid } from 'src/components/organisms/CustomDataGrid';
import { generateTablePageButtons } from 'src/utils/generateTablePageButtons';
import { useProductLinesTable } from 'src/hooks/table/configs/useProductLinesTable';



export const ProductLines = () => {
    const [columns, tableSettings] = useProductLinesTable();






    return (
        <>
            <PageHeader  {...{
                title: "Product Lines",
                subTitle: "View and edit product lines",
                components: [

                    ...generateTablePageButtons(tableSettings),
                    { component: <CustomButton title="New Product Line" icon={<AddTwoToneIcon />} actionUrl="/products/product-lines/create" /> },                    
                    
                ],
            }} />
            <ContentCardsContainer >
                <ContentCard {...{ cardId: "ProductLines", cardTypes: [CardType.noHeader], contentPadding: 0 }}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>
            </ContentCardsContainer>
            <Footer />
        </>
    );

}



export default ProductLines;


